export default "__VITE_ASSET__DnnpE54M__"